import { api } from '../../utils/api'
import Notes from '../shared/Notes'

/**
 * DealNotes: the shared Notes panel wired to a deal's notes.
 *
 * Append-only internal staff comments linked to a HubSpot deal id. Used both in
 * the quote-requested "Add note" popup and in the deal detail modal's "Show
 * Notes" section.
 */

export default function DealNotes({ dealId }) {
  return (
    <Notes
      sourceKey={dealId}
      loadNotes={() => loadDealNotes(dealId)}
      addNote={(text) => addDealNote(dealId, text)}
      variant="cards"
    />
  )
}

async function loadDealNotes(dealId) {
  const res = await api.get(`/api/deals/${dealId}/notes`)
  return {
    notes: (res.notes || []).map(fromDealNote),
    partial: res.partial === true
  }
}

// Returns nothing, so the panel loads the list again and shows the server's copy.
async function addDealNote(dealId, text) {
  await api.post(`/api/deals/${dealId}/notes`, { content: text })
}

function fromDealNote(note) {
  return {
    id: note.id,
    author: note.created_by_name,
    createdAt: note.created_at,
    text: note.content,
    kind: 'note'
  }
}
